import { Component, Input } from '@angular/core';
import { provideTranslocoScope, TranslocoService } from '@ngneat/transloco';
import { map } from 'rxjs';
import { PLATFORM_TRANSLOCO_SCOPE } from '../../platform-transloco-scope';
import { YATTA_IMPRINT_URL, YATTA_PRIVACY_POLICY_URL, YATTA_TERMS_OF_SERVICE_URL } from '../legal-links';
import { LegalWording } from '../legal-wording';

@Component({
  selector: 'yat-simple-copyright-footer',
  templateUrl: './simple-copyright-footer.component.html',
  styleUrls: ['./simple-copyright-footer.component.scss'],
  providers: [provideTranslocoScope(PLATFORM_TRANSLOCO_SCOPE)]
})
export class SimpleCopyrightFooterComponent {
  constructor(private translocoService: TranslocoService) {}

  @Input()
  staticKeys?: Record<LegalWording, string>;

  readonly PRIVACY_POLICY_URL$ = this.translocoService.langChanges$.pipe(map(lang => YATTA_PRIVACY_POLICY_URL(lang)));
  readonly TERMS_OF_SERVICE_URL$ = this.translocoService.langChanges$.pipe(map(lang => YATTA_TERMS_OF_SERVICE_URL(lang)));
  readonly IMPRINT_URL = YATTA_IMPRINT_URL;

  currentYear = new Date().getFullYear();
}
